import {addLayer, getLayerByName, setVisibleByLayerName} from "@/helpers/ol/ol-layer-helper";
import {initWebComponent} from "@/helpers/web-component-helper";
import {getBySelector, hideElementsBySelector, removeClassBySelector} from "@/helpers/element-helper.js";
import {initBoostrapSlider, updateBootstrapSlider} from "@/helpers/bootstrap-slider-helper.js";
import Slider from "bootstrap-slider";
import {ImageWMS} from "ol/source";
import {Tile} from "ol";
import ImageLayer from "ol/layer/Image.js";
import TileLayer from "ol/layer/Tile.js";

export class OlBackgroundSwitcherComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('div');
        let innerHTML = `
            <div id="divBackgroundSwitcher" class="d-none" style="
              width: 245px;
              position: absolute;
              bottom: 160px;
              background-color: white;
              border-radius: 10px;
              margin-left: 10px;
              padding: 10px;
              border:1px solid #5d6378;
            ">
             <span style="margin-left:5px">Transparantie</span>
             <div class="slider-primary pl-2 pr-2">
                <input
                    id="slider"
                    class="bs-slider-variant"
                    type="text"
                    name="somename"
                    data-provide="slider"
                    data-slider-min="0"
                    data-slider-max="100"
                    data-slider-step="1"
                    data-slider-value="100"
                    data-slider-tooltip="hide"
                >
            </div>
            </div>
        `

        let count = 0
        let active = ''
        window.settings.backgroundLayers.map( (backgroundLayer, key) => {

            active = ''
            if (key === 0) {
                innerHTML += `
                <div class="ol-switch-layer ol-control-active ol-control-large" data-id="` + backgroundLayer.BookmarkPresentationID + `">
                       <button class="btnLuchtFoto" style="background-image: url(` + backgroundLayer.Legend + `)"></button>
                       <p class="ol-switch-layer-name">` + backgroundLayer.DisplayName + `</p> 
                </div>`
            }

            if(window.settings.backgroundLayers.find(backgroundLayer => backgroundLayer.Checked)) {
                if (backgroundLayer.Checked) {
                    active = 'active'
                }
            } else {
                if (key === 0) {
                    active = 'active'
                }
            }

            if(backgroundLayer.BookmarkGroupID && layersLoaded.find(layer => layer.BookmarkGroupID === backgroundLayer.BookmarkGroupID) !== undefined) {

            } else {


                // let style = 'left: ' + (10 + count * 130) + 'px;'

                innerHTML += `
                <div class="ol-switch-layer  ol-control-active ol-control-small d-none ${active}" data-group-id="${backgroundLayer.BookmarkGroupID}" data-id="` + backgroundLayer.BookmarkPresentationID + `">
                       <button class="btnLuchtFoto" style="background-image: url(` + backgroundLayer.Legend + `)"></button>
                       <p class="ol-switch-layer-name">` + backgroundLayer.DisplayName + `</p> 
                </div>`
                count++
            }

            window.layersLoaded.push(backgroundLayer)
        })

        // super({
        //     element: template,
        //     target: options.target,
        // });

        setTimeout(function() {
            document.querySelectorAll('.ol-control-active').forEach(function(element) {
                element.addEventListener('click', showLayerSwitch.bind(this), false);
            })

            document.querySelectorAll('.ol-control-small').forEach(function(element) {
                element.addEventListener('click', () => {

                    removeBackgroundLayer()

                    const id = element.dataset.id;

                    const layerLoaded = layersLoaded.find(layer => layer.BookmarkPresentationID === parseInt(id))
                    if(layerLoaded.BookmarkGroupID) {
                        layersLoaded.filter(layer => layer.BookmarkGroupID === layerLoaded.BookmarkGroupID).map((layer) => {
                            addLayer(layer.BookmarkPresentationID, true, true)
                        })

                        window.activeBookmarkGroupdID = layerLoaded.BookmarkGroupID
                    } else {
                        addLayer(id, true, true)
                        delete window.activeBookmarkGroupdID
                    }

                    window.activeBookmarkPresentationID = id

                    updateActiveLayer(id)

                    removeClassBySelector('.ol-control-small', 'active')
                    element.classList.add('active')
                })
            })
        }, 0)

        template.innerHTML = innerHTML
        initWebComponent(this, template)

        initSlider()
    }
}

let timeOut
let opacity
let slider
export function initSlider() {

    let activeLayer = window.settings.backgroundLayers.find(backgroundLayer => backgroundLayer.Checked)
    if(!activeLayer) {
        activeLayer = window.settings.backgroundLayers[0]
    }

    slider = new Slider(getBySelector('#slider')).on('slideStop', function(ev, ev2){
        opacity = ev
        updateBackgroundSlider()
    }).on('slide', function(ev){
        opacity = ev
        updateBackgroundSlider()
    });

    slider.setValue(activeLayer.Opacity * 10);
}

export function updateBackgroundSlider() {
    window.settings.backgroundLayers.map((backgroundLayer) => {
        updateBootstrapSlider(backgroundLayer.BookmarkPresentationID, opacity)
    })
}

export function updateBackgroundSliderValue(bookmarkPresentationID) {
    let layer = getLayerByName(bookmarkPresentationID)

    const backgroundLayer = window.settings.backgroundLayers.find(backgroundLayer => backgroundLayer.BookmarkPresentationID === parseInt(bookmarkPresentationID))

    if(backgroundLayer) {
        const backgroundLayerGroups = window.settings.backgroundLayers.filter(backgroundLayerGroup => backgroundLayerGroup.BookmarkGroupID === backgroundLayer.BookmarkGroupID)

        let firstVisibleLayer = undefined
        backgroundLayerGroups.map((backgroundLayerGroup) => {
            const olLayer = getLayerByName(backgroundLayerGroup.BookmarkPresentationID)
            if(olLayer && olLayer.isVisible() && !firstVisibleLayer) {
                firstVisibleLayer = olLayer
            }
        })

        if(firstVisibleLayer) {
            layer = firstVisibleLayer
        }
    }

    if(layer.isVisible()) {
        let opacity
        if (!layer) {
            layer = window.settings.backgroundLayers.find(backgroundLayer => backgroundLayer.BookmarkPresentationID === parseInt(bookmarkPresentationID))
            opacity = layer.Opacity
        } else {
            opacity = layer.getOpacity() * 10
        }
        slider.setValue(opacity * 10);
    }
}

export function showLayerSwitch(event, target) {

    clearTimeout(timeOut)

    if(document.querySelector('.ol-control-small').classList.contains('d-none')) {
        document.querySelectorAll('.ol-control-small').forEach(function(element, key) {
            element.classList.remove('d-none')
        })
    } else {
        timeOut = setTimeout(() => {
            document.querySelectorAll('.ol-control-small').forEach(function(element, key) {
                element.classList.add('d-none')
            })
            hideElementsBySelector('#divBackgroundSwitcher')
        }, 5000)
    }
}

export function updateActiveLayer() {
    const layer = window.settings.backgroundLayers.find(backgroundLayer => backgroundLayer.BookmarkPresentationID === parseInt(window.activeBookmarkPresentationID))
    const element = document.getElementsByClassName('ol-switch-layer')[0]
    if(element) {
        element.getElementsByClassName('ol-switch-layer-name')[0].innerHTML = layer.DisplayName
        element.getElementsByClassName('btnLuchtFoto')[0].style.backgroundImage = `url(` + layer.Legend + `)`
    }
}

export function removeBackgroundLayer(){
    if(window.activeBookmarkGroupdID) {
        layersLoaded.filter(layer => layer.BookmarkGroupID === window.activeBookmarkGroupdID).map((layer) => {
            addLayer(layer.BookmarkPresentationID, false, true)
        })
    } else if(window.activeBookmarkPresentationID) {
        addLayer(window.activeBookmarkPresentationID, false, true)
    }
}



export function showBackgroundLayers() {
    if(window.activeBookmarkGroupdID) {
        layersLoaded.filter(layer => layer.BookmarkGroupID === window.activeBookmarkGroupdID).map((layer) => {
            addLayer(layer.BookmarkPresentationID, true)
        })
    } else if(window.activeBookmarkPresentationID) {
        addLayer(window.activeBookmarkPresentationID, true)
    }
}

export function hideBackgroundLayers() {
    if(window.activeBookmarkGroupdID) {
        layersLoaded.filter(layer => layer.BookmarkGroupID === window.activeBookmarkGroupdID).map((layer) => {
            addLayer(layer.BookmarkPresentationID, false)
        })
    } else if(window.activeBookmarkPresentationID) {
        addLayer(window.activeBookmarkPresentationID, false)
    }
}
